"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";

export const trialHeroBannerDefaultValues = {
  tabletImg:
    "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F8ffca99c7ff4421f904e63edc9935589",
  mobileImg:
    "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F8ffca99c7ff4421f904e63edc9935589",
  img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F8ffca99c7ff4421f904e63edc9935589",
  heading: "Experience Ploom",
  loggedAvailableTitle: "Your trial is available now",
  loggedFinishedTitle: "Your trial has ended",
  unloggedTitle: "Try Ploom for free",
  availableDescription:
    "Experience the unique heated tobacco experience with our free trial kit.",
  finishedDescription:
    "Thank you for trying Ploom. We hope you enjoyed the experience.",
  actionButtonAvailableTitle: "Get your trial",
  actionButtonAvailableUrl: "/trial/request",
  actionButtonFinishedTitle: "Shop now",
  actionButtonFinishedUrl: "/shop",
  actionButtonLoggedOutTitle: "Sign in",
  actionButton2AvailableTitle: "Learn more",
  actionButton2AvailableUrl: "/about",
  actionButton2FinishedTitle: "See offers",
  actionButton2FinishedUrl: "/offers",
  actionButton2LoggedOutTitle: "Register",
  actionButton2LoggedOutUrl: "/register",
  signInUrl: "/sign-in",
};

export const trialHeroBannerInputs = [
  {
    name: "data",
    type: "object",
    required: true,
    subFields: [
      {
        name: "tabletImg",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "mobileImg",
        type: "file",
        required: true,
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "img",
        type: "file",
        required: true,
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "heading",
        type: "string",
        required: true,
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "loggedAvailableTitle",
        type: "string",
        required: true,
      },
      {
        name: "loggedFinishedTitle",
        type: "string",
        required: true,
      },
      {
        name: "unloggedTitle",
        type: "string",
        required: true,
      },
      {
        name: "availableDescription",
        type: "string",
        required: true,
      },
      {
        name: "finishedDescription",
        type: "string",
        required: true,
      },
      {
        name: "actionButtonAvailableTitle",
        type: "string",
      },
      {
        name: "actionButtonAvailableUrl",
        type: "string",
      },
      {
        name: "actionButtonFinishedTitle",
        type: "string",
      },
      {
        name: "actionButtonFinishedUrl",
        type: "string",
      },
      {
        name: "actionButtonLoggedOutTitle",
        type: "string",
      },
      {
        name: "actionButton2AvailableTitle",
        type: "string",
      },
      {
        name: "actionButton2AvailableUrl",
        type: "string",
      },
      {
        name: "actionButton2FinishedTitle",
        type: "string",
      },
      {
        name: "actionButton2FinishedUrl",
        type: "string",
      },
      {
        name: "actionButton2LoggedOutTitle",
        type: "string",
      },
      {
        name: "actionButton2LoggedOutUrl",
        type: "string",
      },
      {
        name: "signInUrl",
        type: "string",
        required: true,
      },
    ],
    defaultValue: trialHeroBannerDefaultValues,
  },
] as const satisfies Inputs;

export const TrialHeroBannerComponent: RegisteredComponent = {
  name: "TrialHeroBanner",
  component: dynamic(async () => await import("./TrialHeroBanner")),
  inputs: trialHeroBannerInputs,
};
